// ----- Toast Notification Function -----
export function showGlobalToast(message: string, type: 'success' | 'error' | 'celebration' = 'success') {
  window.dispatchEvent(new CustomEvent('global-toast', { detail: { message, type } }));
}
